import { IConfig } from '@cian/config/shared';
import { IPromoModalConfig } from '../../types/promo';

const PROMO_MODAL_CONFIG_KEY = 'Newbuilding.PromoModalConfig';

export const getPromoModalConfig = (config: IConfig): IPromoModalConfig | null => {
  return config.get<IPromoModalConfig>(PROMO_MODAL_CONFIG_KEY);
};
